import { boolean, number, object, setLocale, string } from 'yup'

setLocale({
  mixed: {
    default: 'common.required',
    notType: 'common.required',
    required: 'common.required'
  },
  number: {
    lessThan: 'common.required',
    max: 'common.required',
    min: 'common.required',
    moreThan: 'common.required'
  }
})

export default object().shape({
  description: string().required(),
  end_date: string().required(),
  fare_value: number().required().moreThan(0),
  partner_hotel_room_id: string().notRequired(),
  pension: boolean().required(),
  start_date: string().required(),
  tax_value: number().required().moreThan(0)
})
